import { type InferType, object, ref, string } from "yup";
import { isUSA } from "../../../../../common/utils";
import { AddressInputSchemaGenerator } from "../../../../SharedAddressInput/constants";
import { getNameFromCountry } from "../../../mappers";

export enum AccountDetailsInputFields {
  AccountName = "accountName",
  AccountNumber = "accountNumber",
  ConfirmAccountNumber = "confirmAccountNumber",
  AdditionalInstructions = "additionalInstructions",
  AddressCountry = "country",
  AddressZip = "zip",
  AddressProvince = "province",
  AddressState = "state",
  AddressCity = "city",
  AddressStreetLine1 = "streetLine1",
  AddressStreetLine2 = "streetLine2",
}

export const ADDITIONAL_INSTRUCTIONS_MAX_LENGTH = 30;

export const EftAccountDetailsInputSchema = object()
  .shape({
    [AccountDetailsInputFields.AccountName]: string()
      .required("Required field")
      .max(140, "Must be 140 characters or less")
      .matches(/\S/, "Account name cannot be just spaces."),
    [AccountDetailsInputFields.AccountNumber]: string()
      .required("Required field")
      .matches(/^[0-9]{7,12}$/, "Account number must be between 7 and 12 digits"),
    [AccountDetailsInputFields.ConfirmAccountNumber]: string()
      .oneOf([ref(AccountDetailsInputFields.AccountNumber)], "Must match account number")
      .required("Required field"),
    [AccountDetailsInputFields.AdditionalInstructions]: string().max(
      ADDITIONAL_INSTRUCTIONS_MAX_LENGTH,
      `Must be ${ADDITIONAL_INSTRUCTIONS_MAX_LENGTH} characters or less`,
    ),
  })
  .concat(
    AddressInputSchemaGenerator({
      testIsUSA: (country) => isUSA(getNameFromCountry(country)),
      zipRequiredForNonUS: false,
    }),
  );

export type EftAccountDetailsInputType = InferType<typeof EftAccountDetailsInputSchema>;
